<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--会员添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="userForm"
				:model="userInfo" :label-width="90">
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem label="账号" prop="Name">
						<Input :disabled="modal.canInput" v-model="userInfo.Name" placeholder="账号"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="用户名称" prop="DisplayName">
						<Input :disabled="modal.canInput" v-model="userInfo.DisplayName" placeholder="用户名称"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem label="登录密码" prop="Password">
						<Input :disabled="modal.type=='up'" v-model="userInfo.Password" placeholder="登录密码"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="邮箱" prop="Email">
						<Input :disabled="modal.canInput" v-model="userInfo.Email" placeholder="邮箱"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="手机号码" prop="Phone">
						<Input :disabled="modal.canInput" v-model="userInfo.Phone" placeholder="手机号码"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="状态" prop="Status">
						<Select :disabled="modal.canInput" placeholder="状态" v-model="userInfo.Status">
							<Option :value='0'>正常</Option>
							<Option :value='9'>锁定</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="角色" prop="RoleId">
						<Select placeholder="角色" v-model="userInfo.RoleId">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in RoleList" :value="item.Id">
								{{item.RoleName}}</Option>
						</Select>
						<!-- <Input :disabled="modal.canInput" v-model="userInfo.RoleId" placeholder="RoleId"></Input> -->
					</FormItem>
					</Col>
					<Col span=12>
					<!-- <FormItem label="运营商Id" prop="OperatorId">
						<Input :disabled="modal.canInput" v-model="userInfo.OperatorId" placeholder="运营商Id"></Input>
					</FormItem> -->
					<FormItem label="运营商" prop="OperatorId">
						<!-- <Input v-model="StationForm.OperatorName" placeholder="输入运营商名称"></Input> -->
						<Select :disabled="modal.canInput" placeholder="运营商" v-model="userInfo.OperatorId">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatorStation"
								:value="item.OperatorId">{{item.OperatorName}}</Option>
						</Select>
					</FormItem>
					</Col>
					<!-- <Col span=12>
					<FormItem label="角色名字" prop="RoleName">
						<Input :disabled="modal.canInput" v-model="userInfo.RoleName" placeholder="角色名字"></Input>
					</FormItem>
					</Col> -->
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem prop="StationArray" label="限制场站:">
						<Select :max-tag-count='4' placeholder="限制场站,留空表示不限制" multiple v-model="userInfo.StationArray">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatorStationFilter"
								:value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="建档人" prop="Creator">
						<Input :disabled='true' v-model="userInfo.Creator" placeholder="建档人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="建档时间" prop="CreateTime">
						<Input :disabled='true' v-model="userInfo.CreateTime" placeholder="建档时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="修改人" prop="Modifier">
						<Input :disabled='true' v-model="userInfo.Modifier" placeholder="修改人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="修改时间" prop="ModifyTime">
						<Input :disabled='true' v-model="userInfo.ModifyTime" placeholder="修改时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('add')">添加</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">取消</Button>
				<Button type="success" @click="modalOk('up')" size="large">修改</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (this.modal.type == 'up') {
					callback();
				} else {
					if (value === '') {
						callback(new Error('输入密码'));
					} else {
						callback();
					}
				}
			};
			return {
				modal: {
					Title: "用户添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				userInfo: {
					// Id
					// 用户名
					// 显示名
					// 登录密码
					// 邮箱
					// 手机号码
					// 状态
					// 状态描述
					// 角色Id
					// 角色描述
					// 角色名字
					// 运营商Id
					// 场站列表
					// 场站列表
					// 创建者
					// 创建时间
					// 修改者
					// 修改时间
					"Id": 0,
					"Name": "",
					"DisplayName": "",
					"Password": "",
					"Email": "",
					"Phone": "",
					"Status": 0,
					"RoleId": 2,
					"OperatorId": "",
					"StationList": "[]",
					"StationArray": [],
					"CreateBy": 0,
					"CreateTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"ModifyBy": 0,
					"ModifyTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"Creator": "string",
					"Modifier": "string"
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,

				/******分割线********/
				OperatorStation: [],
				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Name: [{
						required: true,
						message: '账号',
						trigger: 'blur'
					}],
					DisplayName: [{
						required: true,
						message: '名称',
						trigger: 'blur'
					}],
					Password: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
					// StationArray: [{
					// 	required: true,
					// 	message: '选择场站',
					// 	trigger: 'change',
					// 	type: 'array'
					// }
					// ],
				},
			};
		},
		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "会员添加";
					_this.modal.type = "add";
					_this.ruleInline.Password.required = true;
					_this.userInfo.Id = 0;
					_this.$refs.userForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = "会员修改";
					_this.modal.type = "up";
					_this.ruleInline.Password.required = false;
					_this.$refs.userForm.resetFields()
					console.log(params)
					_this.userInfo = {
						"Id": params.Id,
						"Name": params.Name,
						"DisplayName": params.DisplayName,
						"Password": params.Password,
						"Email": params.Email,
						"Phone": params.Phone,
						"Status": params.Status,
						"RoleId": params.RoleId,
						"OperatorId": params.OperatorId,
						"StationList": params.StationList,
						"StationArray": params.StationArray,
						"CreateBy": params.CreateBy,
						"CreateTime": params.CreateTime,
						"ModifyBy": params.ModifyBy,
						"ModifyTime": params.ModifyTime,
						"Creator": params.Creator,
						"Modifier": params.Modifier,
					};
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					default:
						break;
				}
			},
			//添加
			addUser: function(type) {
				const _this = this;
				_this.$refs.userForm.validate((valid) => {
					console.log("会员" + type + "----" + valid)
					if (valid) {
						let parms = _this.userInfo
						console.log(_this.userInfo)
						_this.$axios.post(webapi.base_api_url + "/System/AddUser", parms, {}).then(res => {
							console.log("新增会员")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(type == 'add' ? '添加成功' : '修改成功');
								_this.$emit('handleSubmit');
								_this.modalOk("cancle")
							} else {
								this.$Message.error(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})
			},
			GetCurrentOperatorStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/System/GetCurrentOperatorStation", {}, {}).then(res => {
					console.log("获取运营商以及旗下场站")
					console.log(res.data)
					if (res.data.Code == 0) {
						//_this.$Message.success('获取成功');
						_this.OperatorStation = res.data.Data.List
					} else {
						_this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')
				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '格式错误',
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '图片太大',
					desc: '文件' + file.name + ' 图片太大请选择小于 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		created() {
			this.GetCurrentOperatorStation()
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
			//直接选属性
			OperatorStationFilter: function() {
				const _this = this
				let staArr = []
				_this.OperatorStation.forEach(function(item, index, arr) {
					if (item.OperatorId == _this.userInfo.OperatorId) {
						staArr = (item.Stations)
					}
				})
				console.log(staArr);
				return staArr
			},
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
